import React, { useState } from "react";
import { Form, Button, Card, Container, Row, Col } from "react-bootstrap";

export default function UserCompte() {
  const [user, setUser] = useState({
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    phone: "+123456789",
    password: "********",
    notifications: true,
    darkMode: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUser((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  return (
    <Container className="py-5">
      <h1 className="text-center mb-4">Mon Compte</h1>

      {/* Section : Mes Informations */}
      <Card className="mb-4 shadow-sm">
        <Card.Header as="h5">Mes Informations</Card.Header>
        <Card.Body>
          <Form>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="formFirstName">
                  <Form.Label>Prénom</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={user.firstName}
                    onChange={handleChange}
                    placeholder="Entrez votre prénom"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formLastName">
                  <Form.Label>Nom</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    value={user.lastName}
                    onChange={handleChange}
                    placeholder="Entrez votre nom"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="formEmail" className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={user.email}
                onChange={handleChange}
                placeholder="Entrez votre email"
              />
            </Form.Group>

            <Form.Group controlId="formPhone" className="mb-3">
              <Form.Label>Téléphone</Form.Label>
              <Form.Control
                type="text"
                name="phone"
                value={user.phone}
                onChange={handleChange}
                placeholder="Entrez votre numéro de téléphone"
              />
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>

      {/* Section : Sécurité du Compte */}
      <Card className="mb-4 shadow-sm">
        <Card.Header as="h5">Sécurité du Compte</Card.Header>
        <Card.Body>
          <Form.Group controlId="formPassword" className="mb-3">
            <Form.Label>Mot de Passe</Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={user.password}
              onChange={handleChange}
              placeholder="Entrez votre mot de passe"
            />
          </Form.Group>

          <Button variant="warning">Changer le mot de passe</Button>
        </Card.Body>
      </Card>

      {/* Section : Préférences */}
      <Card className="mb-4 shadow-sm">
        <Card.Header as="h5">Préférences</Card.Header>
        <Card.Body>
          <Form>
            <Form.Check
              type="switch"
              id="notifications-switch"
              name="notifications"
              label="Activer les notifications"
              checked={user.notifications}
              onChange={handleChange}
              className="mb-3"
            />
            <Form.Check
              type="switch"
              id="darkmode-switch"
              name="darkMode"
              label="Mode sombre"
              checked={user.darkMode}
              onChange={handleChange}
              className="mb-3"
            />
          </Form>
        </Card.Body>
      </Card>

      {/* Bouton de sauvegarde */}
      <div className="text-center mt-4">
        <Button variant="primary" size="lg">
          Sauvegarder les Modifications
        </Button>
      </div>
    </Container>
  );
}
